var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseFilter = function SvgChooseFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8A5F4",
    d: "M16.017 21.2a4.002 4.002 0 0 1-7.634 0H1.4a1.2 1.2 0 0 1 0-2.4h6.983a4.002 4.002 0 0 1 7.634 0H24.6a1.2 1.2 0 0 1 0 2.4zM25.8 12a4 4 0 0 0-7.817-1.2H1.4a1.2 1.2 0 0 0 0 2.4h16.583A4.002 4.002 0 0 0 25.8 12M.2 4a4 4 0 0 1 7.817-1.2H24.6a1.2 1.2 0 0 1 0 2.4H8.017A4.002 4.002 0 0 1 .2 4"
  })));
};
export default SvgChooseFilter;